export const ADMIN_ROLES = {
  REGULAR_ADMINISTRATOR: "regular_administrator",
  SUPER_ADMINISTRATOR: "super_administrator",
  INVIZA_SUPER_ADMINISTRATOR: "inviza_super_administrator",
} as const;

export type AdminRole = (typeof ADMIN_ROLES)[keyof typeof ADMIN_ROLES];

export interface Admin {
  id: number;
  name: string;
  surname: string;
  email: string;
  role: AdminRole;
}
